var map = {
	"./Isotip.jpg": 73416,
	"./catalunyaen_comublanc.jpg": 31506,
	"./catalunyaencomunegre.jpg": 62800,
	"./catcomu_logo_blanc.png": 54119,
	"./catlaunyaencomucolor.jpg": 61026,
	"./civicrm-logo.png": 3341,
	"./logo_catencomu.svg": 83240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;